import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'readableList',
  standalone: false,
})
export class ReadableListPipe implements PipeTransform {
  public transform(input: unknown[] | null | undefined): string {
    const values = (input || []).filter((value): value is string => typeof value === 'string' && !!value)

    if (values.length <= 1) return values[0] || ''
    if (values.length === 2) return `${values[0]} and ${values[1]}`

    return `${values.slice(0, -1).join(', ')}, and ${values[values.length - 1]}`
  }
}
